(function() {
  'use strict';

  if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

  var TRACKED_SECTIONS = new Set();

  function trackSectionView(entry) {
    var section = entry.target;
    var sectionType = section.dataset.trackSection;
    var sectionId = section.dataset.sectionId || '';

    if (!sectionType || TRACKED_SECTIONS.has(sectionType + sectionId)) return;

    TRACKED_SECTIONS.add(sectionType + sectionId);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: sectionType + '_view',
      section_id: sectionId
    });
  }

  var observer = new IntersectionObserver(
    function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          trackSectionView(entry);
        }
      });
    },
    { threshold: 0.3 }
  );

  function initTracking() {
    document.querySelectorAll('[data-track-section]').forEach(function(el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }
})();
